// value จาก backend (CompanySize enum) → ป้ายภาษาไทยแบบทางการ — ส่ง/เก็บ value เดิมเสมอ เปลี่ยนเฉพาะที่แสดง
const COMPANY_SIZE_LABELS: Record<string, string> = {
  '1-10': '1–10 คน',
  '11-50': '11–50 คน',
  '51-200': '51–200 คน',
  '201-500': '201–500 คน',
  '501-1000': '501–1,000 คน',
  '1000+': 'มากกว่า 1,000 คน',
}

export const companySizeLabel = (value: string | null | undefined): string =>
  (value && COMPANY_SIZE_LABELS[value]) || value || ''
